import { useContext, useEffect, useRef, useState } from "react"
import { MainContext } from "../../controllers/main"
import { useNavigate } from "react-router-dom"
import { registerPageEvent } from "../../services/utils/utils"
import QuizDesktop from "../../components/quiz/QuizDesktop"
import { QuizzesContext } from "../../controllers/quizzes"
import QuizMobile from "../../components/quiz/QuizMobile"

const Quiz = () => {
  const navigate = useNavigate()
  const { isMobile, currentMission } = useContext(MainContext)
  const {
    currentQuiz,
    setSubmitLoading,
    getQuizzesAndSetCurrentQuiz,
    submitQuiz,
  } = useContext(QuizzesContext)

  // redirect to landing if currentMission isn't present
  // else set current quiz
  useEffect(() => {
    if (!currentMission) {
      navigate("/")
    } else {
      getQuizzesAndSetCurrentQuiz()
    }
  }, [])

  // register google analytics event
  useEffect(() => {
    registerPageEvent("quiz")
  }, [])

  // quiz logic
  const [answer, setAnswer] = useState<string>("")
  const [isAnswerCorrect, setIsAnswerCorrect] = useState<boolean | null>(null)

  // mission completed feedbacks
  const [missionFeedbackOpen, setMissionFeedbackOpen] = useState<boolean>(false)

  // check if currentMission changed to show feedback
  const isFirstRender = useRef<boolean>(true)

  useEffect(() => {
    if (!isFirstRender.current && currentMission && currentMission.satisfied) {
      setSubmitLoading(false)
      setMissionFeedbackOpen(true)
    } else {
      isFirstRender.current = false
    }
  }, [currentMission])

  // on quiz submit
  const onQuizSubmit = () => {
    if (answer === currentQuiz?.correctAnswer) {
      setIsAnswerCorrect(true)
    } else {
      setIsAnswerCorrect(false)
    }

    submitQuiz(
      answer === currentQuiz?.correctAnswer,
      currentMission!.missionId,
      currentQuiz!.id,
      answer
    )
  }

  return isMobile ? (
    <QuizMobile
      answer={answer}
      setAnswer={setAnswer}
      isAnswerCorrect={isAnswerCorrect}
      missionFeedbackOpen={missionFeedbackOpen}
      onQuizSubmit={onQuizSubmit}
    />
  ) : (
    <QuizDesktop
      answer={answer}
      setAnswer={setAnswer}
      isAnswerCorrect={isAnswerCorrect}
      missionFeedbackOpen={missionFeedbackOpen}
      onQuizSubmit={onQuizSubmit}
    />
  )
}

export default Quiz
